module.exports = __webpack_public_path__ + "img/logo-knop.83bbf765.png";